import { Box, Text } from '@chakra-ui/react';
import { QRCodeSVG } from 'qrcode.react';

import FeedbackStatusCard from './FeedbackStatusCard';

const DesktopHandoff = ({ firstName }: { firstName: string | null }) => (
  <FeedbackStatusCard
    emoji="👋"
    title={firstName ? `Hey ${firstName}!` : 'Hey there!'}
    body="This survey is answered out loud, so it works best on your phone."
    hideBackLink
  >
    <Box mt={7} p={4} bg="white" border="1px solid" borderColor="gainsboro" borderRadius="14px">
      <QRCodeSVG value={window.location.href} size={196} />
    </Box>
    <Text mt={5} fontSize="15px" fontWeight={700} color="leaseEndBlue">
      Scan with your phone to get started
    </Text>
  </FeedbackStatusCard>
);

export default DesktopHandoff;
